<div class="semester-picker-container">
    <!-- Wrapper del input con el placeholder dentro -->
    <div class="semester-picker-wrapper">
        <div class="semester-input-wrapper">
            <input
                [value]="formattedDate"
                (click)="openDatePicker()"
                readonly
                [placeholder]="placeholder"
                class="semester-input" />
        </div>

        <div class="underline"></div>
    </div>

    <!-- Modal para seleccionar año y semestre -->
    <div
        class="modal fade"
        [class.show]="showDatePicker"
        [style.display]="showDatePicker ? 'block' : 'none'">
        <div class="modal-dialog modal-md">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Seleccionar fecha</h5>
                    <button
                        type="button"
                        class="close"
                        (click)="closeDatePicker()">
                        <span>&times;</span>
                    </button>
                </div>

                <div class="modal-body">
                    <div class="selectors-container">
                        <!-- Selector de Año -->
                        <div class="year-selector">
                            <div class="form-group mb-0">
                                <label for="anios" class="form-label">
                                    Año:
                                </label>
                                <select
                                    id="anios"
                                    class="form-control form-control-sm"
                                    [(ngModel)]="selectedYear">
                                    <option
                                        *ngFor="let year of years"
                                        [value]="year">
                                        {{ year }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <!-- Selector de Semestre -->
                        <div class="semester-selector">
                            <div class="form-group mb-0">
                                <label for="semester-date" class="form-label">
                                    Semestre:
                                </label>
                                <select
                                    id="semester-date"
                                    class="form-control form-control-sm"
                                    [(ngModel)]="selectedSemester">
                                    <option
                                        *ngFor="let semester of semesters"
                                        [value]="semester.value">
                                        {{ semester.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="button-container">
                        <button
                            class="btn btn-primary btn-sm"
                            (click)="selectDate()">
                            Continuar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Fondo oscuro del modal -->
    <div
        class="modal-backdrop fade"
        [class.show]="showDatePicker"
        [style.display]="showDatePicker ? 'block' : 'none'"></div>
</div>
